module.exports = __webpack_public_path__ + "img/Propane.843b807c.svg";